module.exports = __webpack_public_path__ + "img/comic_digital_person.e81a95e7.png";